__webpack_require__.p = "/apps/bruteforcesettings/js/";